export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const maskPhoneNumber = (phoneNumber: string) => {
  const regex = /^(\+\d{1,3})?\s?[\s()]*(\d*)([\d\s()-]*)(\d{4})$/
  const masked = phoneNumber.replace(regex, (_, p1 = '', p2, p3, p4) => {
    const maskedPart2 = p2 ? p2.replace(/\d/g, '*') : ''
    const maskedPart3 = p3 ? p3.replace(/\d/g, '*') : ''
    const maskedNumber = p1 + maskedPart2 + maskedPart3 + p4

    return maskedNumber.replace(/[\s()-]/g, '')
  })

  return masked
}

export const maskEmail = (email: string) => {
  const regex = /^([\w-_.]+)(@[^@]*\..*)$/
  const masked = email.replace(regex, (_, p1, p2) => {
    let maskedPart
    if (p1.length > 8) {
      maskedPart = p1.slice(0, -6).replace(/[\w-_.]/g, '*')
      const remainingPart = p1.slice(-6)
      return maskedPart + remainingPart + p2
    } else if (p1.length >= 5) {
      const maskLength = Math.ceil(p1.length / 2)
      maskedPart = p1.slice(0, maskLength).replace(/[\w-_.]/g, '*')
      const remainingPart = p1.slice(maskLength)
      return maskedPart + remainingPart + p2
    } else {
      maskedPart = p1.replace(/[\w-_.]/g, '*')
      return maskedPart + p2
    }
  })

  return masked
}

export const sentenceFormat = (string?: string) => capitalizeFirstLetter(string?.toLowerCase() || '')

export const shortenString = (str: string, max?: number) => {
  const maxLength = max || 20
  return str.length > maxLength ? `${str.slice(0, maxLength)}...` : str
}
